const EXTRA_SMALL = 731;
const SMALL = 732;
const MEDIUM = 732;
const LARGE = 1056;
const EXTRA_LARGE = 9999;

export const BREAKPOINT = {
  EXTRA_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
  EXTRA_LARGE,
};
